import React, { useCallback, useState, useEffect } from 'react';
import { uploadPhotoAddressWeb } from 'common/appInterface';

const AddressUploadTest = (props) => {

  const callback = useCallback(() => {
      props.setMain(true);
  }, [props]);

  const [returnReceiveRelationCheck, setReturnReceiveRelationCheck] = useState("");
  const [returnImageValue, setReturnImageValue] = useState("");

  // uploadPhotoAddress_Web 처리 (WEB > APP)
  const uploadPhotoAddress = useCallback(() => {
    uploadPhotoAddressWeb();
  }, []);

  // completedPhotoAddress_App 처리 (APP > WEB)
  const completedPhotoAddressApp = useCallback((event) => {
    setReturnReceiveRelationCheck(event.detail.receiveRelationCheck);
    setReturnImageValue(event.detail.imageValue);
    alert("completedPhotoAddress_App catch...");
  }, []);

  // APP이벤트 공통 수신처리 (APP > WEB)
  useEffect(() => {
    document.addEventListener("backpress", callback);
    return () => document.removeEventListener("backpress", callback);
  }, [callback]);

  // APP이벤트 공통 수신처리 (APP > WEB)
  useEffect(() => {
    document.addEventListener("addressUpload", completedPhotoAddressApp);
    return () => document.removeEventListener("addressUpload", completedPhotoAddressApp);
  }, [completedPhotoAddressApp]);

  return (
    <div id="container">
      <section className="contents">
        <div className="singUpWrapSub">
          <div className="txtWrap">
            <p className="mainTxt">uploadPhotoAddress_Web</p>
          </div>
          <div className="conWrap mgt30">
            <div className="btnWrapTy01">
              <button type="button" className="btnPrimaryTy01" onClick={uploadPhotoAddress}><span>uploadPhotoAddress_Web Call</span></button>
            </div>
          </div>
        </div>
        <div className="singUpWrapSub">
          <div className="txtWrap">
            <p className="mainTxt">completedPhotoAddress_App</p>
          </div>
          <div className="conWrap mgt30">
            <div className="inputBoxTy01"> 
              <label className="mgb20">
                <input type="text" value={returnReceiveRelationCheck} readOnly />
                <span>receiveRelationCheck</span>
              </label>
            </div>
            <div className="textareaBox mgb120"> 
              <label className="" style={{margin: "0 0 45px", position: "relative", display: "inline-block", width: "100%"}}>
                <textarea type="text" value={returnImageValue} readOnly style={{marginTop: "10px", padding: "5px 10px"}} />
                <span style={{opacity: ".5", transform: "scale(0.75) translateY(-80%) translateX(0px)", transformOrigin: "left", padding: "10px 0", fontSize: "18px", pointerEvents: "none", position: "absolute", left: "0", top: "0", transition: "0.2s", transitionTimingFunction: "cubic-bezier(0.25, 0.1, 0.25, 1)"}}>imageValue</span>
              </label>
            </div>
          </div>
        </div>
      </section>
      <div className="btnArea">
        <div className="btnWrapTy01">
          <button type="button" className="btnPrimaryTy01 mgb60" onClick={callback}><span>메뉴복귀</span></button>
        </div>
      </div>
    </div>
  );
}

export default AddressUploadTest;